import { Small, Toggle } from "orcs-design-system";
import React from "react";

import { useThemeSwitchingContext } from "src/contexts/ThemeSwitchingContext";
import { EVENT_TRACKING } from "src/consts/eventTracking";
import { trackEvent } from "src/services/segment";

const ThemeSwitchToggle = () => {
  const { isDarkTheme, themeSwitcher } = useThemeSwitchingContext();

  const onDarkThemeChange = () => {
    const switchToDark = !isDarkTheme;
    themeSwitcher(switchToDark);
    trackEvent(EVENT_TRACKING.SETTING_CHANGED, {
      setting: "theme",
      value: switchToDark ? "dark" : "light",
    });
  };

  return (
    <>
      <Small fontWeight="600" fontSize="0">
        Dark theme
      </Small>
      <Toggle
        id="darkTheme"
        label={isDarkTheme ? "On" : "Off"}
        small
        checked={isDarkTheme}
        onChange={onDarkThemeChange}
      />
    </>
  );
};

export default React.memo(ThemeSwitchToggle);
